import React, { useState } from 'react';
// @ts-ignore
import styles from './PasswordResetRequest.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import InputField from '../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { joinClasses } from '../../../../Utils/className.util';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import AccountPagePanel from '../AccountPagePanel/AccountPagePanel';
import ConfirmationModal from '../../../Base/Components/Confirmation/ConfirmationModal';
import NetteApiClient from '../../../../Services/NetteApiClient';
import { useAppContext } from '../../../../Services/AppContext';

const PasswordResetRequest: React.FC = () => {
	const { t } = useTranslation();
	const { displayError } = useApiClient();
	const { redirectLoginPage } = useAppContext();
	const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

	const validationSchema = yup.object({
		email: yup
			.string()
			.email(t('component.passwordResetRequest.emailFormatValidation'))
			.required(t('component.passwordResetRequest.emailRequired')),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		try {
			const response = await apiClient.post(`/authentication/password-reset`, {
				email: values.email,
			});
			if (response.status === 200) {
				setIsConfirmationOpen(true);
			}
		} catch (e) {
			displayError(e);
		}
	};

	const handleBack = async () => {
		if (redirectLoginPage) {
			await NetteApiClient.get(redirectLoginPage);
		}
	};

	const afterOnConfirmationClose = () => {
		setIsConfirmationOpen(false);
		handleBack();
	};

	return (
		<AccountPagePanel title='component.passwordResetRequest.title'>
			<>
				<FormWrapper formMethods={formMethods}>
					<InputField
						name='email'
						label='component.passwordResetRequest.email'
						isRequired
					/>
					<div className={styles.controlsWrapper}>
						<SubmitButton
							onSubmit={handleSubmit}
							className={joinClasses(['btn btn-primary w-100', styles.button])}
							title='component.passwordResetRequest.submitButton'
						/>
						<LinkButton
							onClick={handleBack}
							title='component.passwordResetRequest.cancelButton'
							theme={Theme.BLUE}
							className={styles.cancelButton}
						/>
					</div>
				</FormWrapper>
				{isConfirmationOpen && (
					<ConfirmationModal
						imageSource='/dist/icons/v2/check-green.svg'
						title='component.passwordResetRequest.confirmationTitle'
						text={t('component.passwordResetRequest.confirmationText') ?? ''}
						isOpen
						onClose={afterOnConfirmationClose}
					/>
				)}
			</>
		</AccountPagePanel>
	);
};

export default PasswordResetRequest;
